import { ModalTarifaClienteTmov } from '@sotran/lib-shipper';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useState } from 'react';

import { TableTmovShipper } from '../../../../components/Table';
import { Message, TextColor } from '../../../../styles/global';
import TarifaTmovContext from '../contexts/TarifaTmovContext';
import { validateLoteIntegracao } from '../helpers/validators';
import ModalDelete from '../Modal/modalDelete';
import { getColumns } from './columns';
import { EditableCell } from './editableCell';
import { EditableRow } from './editableRow';

export default function ListagemCsv({ dadosCsv, setDadosCsv }) {
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [itemDelete, setItemDelete] = useState({});
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [showModalTarifa, setShowModalTarifa] = useState(false);
  const tarifaTmovCliente = useContext(TarifaTmovContext);

  const handleShowModalDelete = record => {
    setShowModalDelete(true);
    setItemDelete(record);
  };

  const handleDeleteRow = useCallback(() => {
    setConfirmDelete(false);
    setDadosCsv(dadosCsv.filter(item => item.index !== itemDelete.index));
  }, [dadosCsv, itemDelete.index, setDadosCsv]);

  useEffect(() => {
    if (confirmDelete) handleDeleteRow();
  }, [confirmDelete, handleDeleteRow]);

  const handleSaveLoteIntegracao = loteIntegracao => {
    const novoDado = [...dadosCsv];
    const index = novoDado.findIndex(
      dadoCsv => loteIntegracao.key === dadoCsv.index
    );
    const item = novoDado[index];
    novoDado.splice(index, 1, {
      ...item,
      ...validateLoteIntegracao(loteIntegracao),
    });
    setDadosCsv(novoDado);
  };

  function showModalTarifas() {
    setShowModalTarifa(true);
  }

  const columnsTable = getColumns(
    handleShowModalDelete,
    handleSaveLoteIntegracao,
    showModalTarifas
  );
  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  return (
    <>
      <ModalDelete
        showModalDelete={showModalDelete}
        setShowModalDelete={setShowModalDelete}
        setConfirmDelete={setConfirmDelete}
      />
      <TableTmovShipper
        components={components}
        rowClassName="editable-row"
        className="pt-30"
        rowKey="index"
        dataSource={
          dadosCsv.length &&
          dadosCsv.map(dado => ({
            ...dado,
            key: dado.index,
          }))
        }
        pagination={false}
        scroll={{ x: 3400 }}
        columns={columnsTable}
      />
      {tarifaTmovCliente.tarifas ? (
        <ModalTarifaClienteTmov
          tarifas={tarifaTmovCliente.tarifas}
          tipoTarifa={tarifaTmovCliente.tipoTarifa}
          visible={showModalTarifa}
          setVisible={setShowModalTarifa}
        />
      ) : (
        ''
      )}

      <Message margin="0">
        <TextColor color="#ff0000">*</TextColor>
        &nbsp;O ICMS e demais impostos não estão sendo considerados para o
        cálculo do frete.
      </Message>
    </>
  );
}

ListagemCsv.propTypes = {
  dadosCsv: PropTypes.arrayOf(PropTypes.object).isRequired,
  setDadosCsv: PropTypes.func.isRequired,
};
